import RateOptions from './RateOptions'

export default RateOptions
